import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserAccountRoutingModule } from './user-account-routing.module';
import { UserAccountComponent } from './pages/user-account/user-account.component';
import { SharedModule } from '../../shared/shared.module';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { FriendProgramModule } from '../friend-program/friend-program.module';

@NgModule({
    declarations: [UserAccountComponent],
    imports: [
        CommonModule,
        UserAccountRoutingModule,
        SharedModule,
        IonicModule,
        FormsModule,
        FriendProgramModule,
    ],
})
export class UserAccountModule {}
